export const footerStatic = {
  footer_nav: [
    { id: 1, title: 'Contacts', link: '/contacts/' },
  ],
  copy: '2021 All rights reserved. \nZEROTABLETOP  |  P.IVA 07986030968',
};
